<template>
  <div>
    <!-- breadcrumb start -->
    <breadcrumb-one 
      banner_height="page-banner-height-2" 
      title="Checkout Details" 
      subtitle="Checkout Details">
    </breadcrumb-one>
    <!-- breadcrumb end -->

    <!-- checkout coupons area start -->
     <!--
    <checkout-coupons></checkout-coupons>
    -->
    <!-- checkout coupons area end -->
    <br/>
    <!-- checkout area start -->
    <checkout-area></checkout-area>
    <!-- checkout area end -->

    <!-- cta area start -->
    <cta-area></cta-area>
    <!-- cta area end -->
  </div>
</template>

<script lang="js">
import BreadcrumbOne from '@/components/breadcrumb/breadcrumb-one.vue';
import CheckoutArea from '@/components/checkout/checkout-area.vue';
import CtaArea from '@/components/cta/cta-area.vue';
//import CheckoutCoupons from '@/components/checkout/checkout-coupons.vue';
export default {
  name: "CheckoutPage",
  components: {
      BreadcrumbOne,
      CheckoutArea,
      //CheckoutCoupons,
      CtaArea
    },
  data() {
    return {};
  },
  created() {
    this.setSeoMeta();
  },
  methods: {
    setSeoMeta() {
      // Assuming `useSeoMeta` is a global or utility function.
     
    },
  },
};
</script>
